import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import KeyImageStar from "../../../../components/SVGComponents/Tools/KeyImageStar";
import { isMobile } from "react-device-detect";

const DICOMDetails = ({ voi, scale, showKeyImageStar, orientation }) => {
  const { t } = useTranslation();
  const { isMPRActive } = useContext(ViewportContext);

  return (
    <>
      <div className="viewport-overlay-dicom" style={{maxWidth : isMobile ? "55%" : "40%"}}>
        {isMPRActive && (
          <div>
            <span className="viewport-overlay-value">
              {orientation ? orientation.toUpperCase() : ""}
            </span>
          </div>
        )}
        {/*showKeyImageStar && <div>
          <KeyImageStar />
        </div>*/}
        <span className="viewport-overlay-key">
          {t("viewer.overlay.zoom")}:{" "}
        </span>
        <span className="viewport-overlay-value">
          {scale.toFixed(2)}
          {" | "}
        </span>
        <span className="viewport-overlay-key">{t("viewer.overlay.l")}: </span>
        <span className="viewport-overlay-value">{voi?.windowCenter?.toFixed(0)} </span>
        <span className="viewport-overlay-key">{t("viewer.overlay.w")}: </span>
        <span className="viewport-overlay-value">{voi?.windowWidth?.toFixed(0)}</span>
      </div>
    </>
  );
};

export default DICOMDetails;
